"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLocationByIp = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Fetch the location information from HTTP request IP. This function is valid only for USA IP's.
 *
 * @public
 *
 * @typeParam T The type of the repository that should be derived from {@link ILocationRepository}
 *
 * @param repository The repository instance to handle location. See {@link locationRepository}
 *
 * @returns An async object with the location information. If there is no information or the IP is not in USA then null is returned
 *
 * @example
 * ```ts
 * const location = await fetchUSALocationByIp(locationRepository);
 * ```
 */
async function fetchLocationByIp(repository) {
    try {
        const location = await repository.fetchLocationByIp();
        return (location === null || location === void 0 ? void 0 : location.country) === 'US'
            ? (0, utils_1.omitKeys)(location, 'country')
            : null;
    }
    catch (error) {
        // TODO: add raygun notification
        return null;
    }
}
exports.fetchLocationByIp = fetchLocationByIp;
//# sourceMappingURL=fetch-location-by-ip.js.map